import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";
import { baseColors } from "../../../baseColors";

const chip = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiChip"] => ({
	root: {
		fontSize: spacing(1.75),
		color: palette.black,
		backgroundColor: palette.grey50,
		borderRadius: "0.4rem",
		padding: "0.8rem 0.8rem",
	},
	label: {
		fontFamily: "RoobertCEZ",
		fontSize: "1.6rem",
		fontWeight: 400,
		padding: "0 0.8rem",
	},
	sizeSmall: {
		padding: "0 1.2rem",
		height: "24px",
	},
	labelSmall: {
		fontSize: "1.2rem",
		letterSpacing: "0.02rem",
		padding: "0",
		paddingLeft: undefined,
		paddingRight: undefined,
	},
	deleteIconSmall: {
		width: "18px",
		height: "18px",
		marginLeft: "0.5rem",
		marginRight: "-0.4rem",
	},
	clickable: {
		"&:hover, &:focus": {
			backgroundColor: palette.grey40,
		},
	},
	deleteIcon: {
		color: palette.grey25,
		"&:hover": {
			color: palette.primary,
		},
	},
	deleteIconColorPrimary: {
		color: palette.white,
		"&:hover": {
			color: palette.primary,
		},
	},
	deletable: {
		"&:focus": {
			backgroundColor: undefined,
		},
	},
	colorPrimary: {
		color: baseColors.white,
		backgroundColor: hexToRGBA(palette.black, 0.2),
		"&.MuiChip-clickable": {
			"&:hover, &:focus": {
				backgroundColor: hexToRGBA(palette.black, 0.4),
			},
		},
	},
});

export default chip;
